import axios from 'axios';

// ── Device token: UUID persistente por dispositivo ─────────────────────────────
function getDeviceToken() {
  let token = localStorage.getItem('_dt');
  if (!token) {
    // Genera UUID v4 sin dependencias
    token = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    localStorage.setItem('_dt', token);
  }
  return token;
}

const api = axios.create({
  baseURL: '/api',
  timeout: 90000 // 90 s — Polly + S3 pueden tardar
});

// Adjunta el device token en cada request automáticamente
api.interceptors.request.use(config => {
  config.headers['X-Device-Token'] = getDeviceToken();
  return config;
});

/**
 * Envía la foto y los datos del formulario al servidor.
 * @param {{ nombre: string, intencion: string, foto: File, codigo?: string }} datos
 * @returns {Promise<Object>} resultado de la lectura
 */
export async function enviarLectura({ nombre, intencion, foto, codigo, mano, tipoManoCliente, ladoManoCliente }) {
  const formData = new FormData();
  formData.append('nombre', nombre);
  formData.append('intencion', intencion);
  formData.append('mano', mano || 'diestra');
  formData.append('foto', foto);
  if (codigo)           formData.append('codigo', codigo);
  if (tipoManoCliente)  formData.append('tipoManoCliente', tipoManoCliente);
  if (ladoManoCliente)  formData.append('ladoManoCliente', ladoManoCliente);

  const { data } = await api.post('/lectura', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  return data;
}

export async function validarCodigoPromo(codigo) {
  const { data } = await api.post('/validar-codigo', { codigo });
  return data;
}

export default api;
